let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kEVX0")).then(() => parcelRequire('2r6Al'));